<template>
  <refonte-modal
    v-bind:show="props.show"
    class="!max-w-[704px]"
    v-on:close="close">
    <template v-slot:modalHeader> <h1>Droit de rétractation</h1> </template>
    <template v-slot:modalBody>
      <div v-if="formation">
        <div>
          En tant que particulier,
          <b>vous bénéficiez d'un droit de rétractation de 14 jours.</b>
        </div>
        <br />
        <div>
          Pour accéder immédiatement à votre module elearning avant la fin de la
          période de rétractation, vous avez la possibilité de renoncer à votre
          droit de rétractation en cliquant sur le bouton
          <b>Accéder à la formation</b>.
        </div>
        <br />
        <div>
          Si vous souhaitez utiliser ce droit, contactez l'organisateur à
          l'adresse suivante {{ formation.organisateurEmail }}
        </div>
        <br />
        <div
          v-if="
            formation.moduleElearning?.dateDebutRetractation &&
            formation.moduleElearning?.dateFinRetractation
          ">
          Période de mon droit de rétractation :
          <span class="bold">
            Du
            {{ formation.moduleElearning.dateDebutRetractation }}
            au
            {{ formation.moduleElearning.dateFinRetractation }}
          </span>
        </div>
        <br />
        <refonte-checkbox
          label="Je renonce à mon droit de rétractation et accède immédiatement au
          module elearning."
          v-bind:value="checked"
          v-on:input="(value) => setCheck(value)" />
      </div>
    </template>
    <template v-slot:modalFooter>
      <refonte-button
        variant="text"
        v-bind:on_click="close">
        Annuler
      </refonte-button>
      <refonte-button
        v-bind:on_click="() => open_elearning_module(formation)"
        v-bind:disabled="!checked">
        Accéder à la formation
      </refonte-button>
    </template>
  </refonte-modal>
</template>

<script setup lang="ts">
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';
  import { ref } from 'vue';
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';
  import RefonteCheckbox from '@/components/refonte/inputs/refonte-checkbox.vue';
  import { RetractationFormation } from '@/types/participant/formations-types';

  const props = withDefaults(
    defineProps<{
      show: boolean;
      on_close: Function;
      class?: string;
      formation?: RetractationFormation;
      open_elearning_module: Function;
    }>(),
    {
      class: ''
    }
  );

  function close() {
    props.on_close();
  }
  const checked = ref<boolean>(false);
  const setCheck = (value: boolean) => {
    checked.value = value;
  };
</script>

<style lang="scss" scoped></style>
